import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.UserList.PermissionsPopupContent', {
    title: 'User permissions',
    save: 'Save',
    accountOwner: 'Account owner',
    contactPaymentDetailsGroup: 'Contact payment details',
    canView: 'Can view list',
    canAdd: 'Can add',
    canEdit: 'Can edit',
    successMessage: 'User permissions has been changed.',
});
